import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, unref as _unref, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pt-[20px] bg-[#ededed]" }
const _hoisted_2 = { class: "max-w-[1400px] w-full container mx-auto" }
const _hoisted_3 = { class: "pt-[60px] pr-[20px] pb-[2%] pl-[10px] max-w-[1400px]" }
const _hoisted_4 = { class: "max-w-[1400px] w-full container mx-auto" }
const _hoisted_5 = { class: "pt-[30px] pr-[20px] pb-[40px] pl-[10px] max-w-[1400px] text-center" }

import { ref, computed, onMounted } from 'vue'
    import offerNavigation from '@/components/SubNavigations/TheOfferNavigation.vue'
    import ContactsTable from '@/components/Contacts/ContactsTable.vue'
    import useContactStore from '@/utils/useContactStore'
    import useOfferStore from '@/utils/useOfferStore'
    import router from '@/router'
    import { Offer } from '@/model/types'

    // Retrieve contact store functions and reactive properties.
    
export default /*@__PURE__*/_defineComponent({
  __name: 'OffersSelectContactView',
  setup(__props) {

    const {
        contacts,
        loading,
        fetchContacts,
        fetchContactsSearch,
        duplicateContact,
        deleteContact,
    } = useContactStore()
    // We also retrieve our HATEOAS-related functions from the offer store.
    const { getHateoasLinks, hasLink } = useOfferStore()

    const searchTerm = ref('')

    // On mount, load the HATEOAS links (if not already available) and the contacts.
    onMounted(async () => {
        await getHateoasLinks() // Assumes this populates internal HATEOAS link cache
        await fetchContacts({ limit: 20, offset: 0, filter: '' })
    })

    // Determine if the current user is restricted (i.e. should see only a few contacts)
    // We assume that full-access users get the "contact/create" link; any user lacking this link is restricted.
    const isRestrictedUser = computed(() => {
        // If there is no "contact/create" link, then treat the user as an Anykey partner (restricted)
        return !hasLink('contact/create')
    })

    // The computed number of contacts to show.
    // For restricted users we use 5; for full-access users, we use 50.
    const contactsCount = computed(() => {
        return isRestrictedUser.value ? 5 : 50
    })

    // The search function: if restricted, always use a limit of 5 results.
    const search = () => {
        const limitVal = isRestrictedUser.value ? 5 : 20
        fetchContactsSearch({ limit: limitVal, offset: 0, filter: searchTerm.value })
    }

    // Function to select a contact and route accordingly.
    const { clearSelectedOfferStore } = useOfferStore()
    const selectContact = (contact: Offer) => {
        // Clear any existing selected offer when creating a new one
        clearSelectedOfferStore()
        router.push('/offers/createoffer/' + contact.contactId + '/0')
    }

    // Stub implementation for load (pagination not implemented here).
    const load = ({ done }: { done: Function }) => {
        console.log('Load not implemented – pagination is disabled for now.')
    }

    // Define breadcrumbs.
    const breadcrumbs = [
        { title: 'Offerten', disabled: false, href: '/offers' },
        { title: 'Kontakt auswählen', disabled: false, href: '/offers/selectcontacts' },
    ]

return (_ctx: any,_cache: any) => {
  const _component_v_breadcrumbs = _resolveComponent("v-breadcrumbs")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(offerNavigation)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_v_breadcrumbs, { items: breadcrumbs }),
      _createElementVNode("div", _hoisted_5, [
        _cache[1] || (_cache[1] = _createElementVNode("h2", { class: "text-left text-2xl font-light mb-[3%]" }, [
          _createElementVNode("strong", null, "Kontakt für Offerte auswählen")
        ], -1)),
        _createVNode(_component_v_card, {
          class: "w-full mx-auto",
          color: "grey-lighten-3"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_text_field, {
                  loading: _unref(loading),
                  density: "comfortable",
                  type: "input",
                  onInput: search,
                  variant: "solo",
                  label: "Bitte Schule auswählen",
                  title: "Schule eingeben",
                  autofocus: "",
                  modelValue: searchTerm.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchTerm).value = $event)),
                  "append-inner-icon": "mdi-magnify",
                  "single-line": "",
                  "hide-details": ""
                }, null, 8, ["loading", "modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(ContactsTable, {
          load: load,
          hasActions: true,
          contacts: _unref(contacts),
          selectMethod: selectContact,
          redirectTo: '/offers/createoffer/',
          duplicateMethod: _unref(duplicateContact),
          contactsCount: contactsCount.value,
          deleteMethod: _unref(deleteContact)
        }, null, 8, ["contacts", "duplicateMethod", "contactsCount", "deleteMethod"]),
        _cache[2] || (_cache[2] = _createElementVNode("hr", null, null, -1))
      ])
    ])
  ], 64))
}
}

})